import {SET_UNSUBSCRIBE_REASONS_LIST} from '../mutation-types';
import {getUnsubscribeReasons} from '../../api/unsubscribe-reason-api';

const initialState = {
    list: []
};

const getters = {
    activeUnsubscribeReasons: state => {
        return state.list.filter(reason => reason.active);
    }
};

const mutations = {
    [SET_UNSUBSCRIBE_REASONS_LIST](state, reasons) {
        state.list = reasons;
    }
};

const actions = {
    loadUnsubscribeReasons({commit}) {
        return new Promise((resolve, reject) => {
            getUnsubscribeReasons()
                .then(reasons => {
                    commit(SET_UNSUBSCRIBE_REASONS_LIST, reasons);
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
        });
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}